// extracted by mini-css-extract-plugin
export var linkText = "_qr-0";